// removed by extract-text-webpack-plugin
module.exports = {"root":"NewsletterHeader__root--3i7et","heading":"NewsletterHeader__heading--UDVyG","author":"NewsletterHeader__author--1DD69","bounce":"NewsletterHeader__bounce--2Ropc"};


//////////////////
// WEBPACK FOOTER
// ./src/subscriptions/components/NewsletterHeader/NewsletterHeader.css
// module id = ./src/subscriptions/components/NewsletterHeader/NewsletterHeader.css
// module chunks = 2